
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine/[regionUrlKey]/[placeUrlKey]/[storeUrlKey]",
      function () {
        return require("private-next-pages/magazine/[regionUrlKey]/[placeUrlKey]/[storeUrlKey].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine/[regionUrlKey]/[placeUrlKey]/[storeUrlKey]"])
      });
    }
  